"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
const mobx_1 = require("mobx");
const rich_agent_1 = require("rich-agent");
const react_mobx_loader_1 = require("react-mobx-loader");
class Store {
    constructor(endpointStore) {
        this.listNeverLoaded = true;
        this.actualities = [];
        this.currentUuid = '';
        this._endpointStore = endpointStore;
        this._listRequest = new rich_agent_1.ApiRequest(this._endpointStore.endpoint + '/actuality/list?maxPerPage={limit}', 'GET');
        this._listRequest.addAuthorizationService(this._endpointStore);
        this.listLoader = new react_mobx_loader_1.CustomLoader(this._listRequest, false);
        mobx_1.reaction(() => this._endpointStore.modeAdmin, modeAdmin => {
            this.loadList(true);
        });
        if (this._endpointStore.modeAdmin) {
            this.loadList(true);
        }
    }
    loadList(force = false) {
        if (this._listRequest.status !== 'pending' && (this.listNeverLoaded || force)) {
            this._listRequest
                .setUrlParam('limit', this.limit + '')
                .send()
                .then(mobx_1.action((response) => {
                this.actualities.splice(0);
                for (const actuality of response.data.results) {
                    if (actuality.valid) {
                        actuality.active = actuality.valid;
                        actuality.current = 'valid';
                    }
                    else {
                        actuality.active = actuality.draft;
                        actuality.current = 'draft';
                    }
                    this.actualities.push(actuality);
                }
                this.listNeverLoaded = false;
            })).catch(mobx_1.action((response) => {
                this.actualities.splice(0);
            }));
        }
    }
    get limit() {
        return 6;
    }
    get filteredAndOrderedActualities() {
        let actualities = this.actualities.slice(0, this.limit);
        if (!this._endpointStore.modeAdmin) {
            actualities = actualities.filter((actuality) => {
                return actuality.current === 'valid';
            });
        }
        return actualities;
    }
    serialize() {
        const s = {
            actualities: [],
            currentUuid: this.currentUuid
        };
        for (const actuality of mobx_1.toJS(this.actualities)) {
            s.actualities.push(actuality);
        }
        return s;
    }
    deserialize(data) {
        this.actualities.splice(0);
        for (const actuality of data.actualities) {
            this.actualities.push(actuality);
        }
        this.listNeverLoaded = this.actualities.length === 0;
    }
}
__decorate([
    mobx_1.observable
], Store.prototype, "listLoader", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "listNeverLoaded", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "actualities", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "currentUuid", void 0);
__decorate([
    mobx_1.computed
], Store.prototype, "filteredAndOrderedActualities", null);
__decorate([
    mobx_1.action
], Store.prototype, "deserialize", null);
exports.Store = Store;
